import { combineReducers } from 'redux';
import productReducer from './AddProducts/ProductReducer';
import cartReducer from './Cart/cartReducer';

const rootReducer = combineReducers({
    products: productReducer,
    carts: cartReducer
})

export default rootReducer;